'use client'

import Image from 'next/image'
import phoneIcon from '/public/assets/images/phones/phone-black.svg'
import './style.css'
import useWindowDimensions from '@/app/hooks/UseWindowDimensions'
import { TailwindConfig } from '@sedomicilier/material-sd'

interface PhoneButtonProps {
  label: string
  className?: string
}

export const phoneNumber = '01 83 64 31 07'
export const phoneHref = 'tel:+33183643107'

const PhoneLink: React.FC<PhoneButtonProps> = ({ label, className }) => {
  const { width } = useWindowDimensions()

  const getLabel = () => {
    if (width! >= parseInt(TailwindConfig.breakpoints.wide.min, 10)) {
      return `${label} ${phoneNumber}`
    } else if (width! >= parseInt(TailwindConfig.breakpoints.tablet.min, 10)) {
      return phoneNumber
    }
    return
  }

  const phoneLinkClassName = className
    ? `link-phone body-2 ${className}`
    : 'link-phone body-2'

  return (
    <a data-testid='phone-link' href={phoneHref} className={phoneLinkClassName}>
      <Image src={phoneIcon} alt='phone icon' />
      {getLabel()}
    </a>
  )
}

export default PhoneLink
